import { SxProps, Theme } from '@mui/material';

export const createStateLayerOverlay = (
  containerColor: string,
  overlayOpacity: number,
  outlineColor?: string,
) => {
  return {
    backgroundColor: containerColor,
    borderColor: outlineColor || undefined,
    '& *': {
      zIndex: 1
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRadius: 'inherit',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'currentColor',
      opacity: overlayOpacity,
      pointerEvents: 'none'
    }
  };
};

export const createStateLayer = (
  theme: Theme,
  containerColor: string,
  outlineColor?: string,
) => {
  const isOutlinedElement = !!outlineColor;
  const disabledStyles = isOutlinedElement ? {
    opacity: 1,
    color: theme.palette.action.disabled,
    borderColor: theme.palette.action.disabledBorder,
    backgroundColor: 'transparent',
    '& svg': {
      color: theme.palette.action.disabled
    }
  } :
    {
      color: theme.palette.action.disabled,
      '& svg': {
        color: theme.palette.action.disabled
      },
      ...createStateLayerOverlay(
        'transparent',
        theme.palette.action.disabledOpacity,
      )
    };

  return {
    position: 'relative',
    '&:hover': {
      ...createStateLayerOverlay(
        containerColor,
        theme.palette.action.hoverOpacity,
        outlineColor,
      ),
      '&.Mui-disabled': disabledStyles
    },
    '&:focus-visible': createStateLayerOverlay(
      containerColor,
      theme.palette.action.focusOpacity,
      outlineColor,
    ),
    '&:active, &.active': createStateLayerOverlay(
      containerColor,
      theme.palette.action.activatedOpacity,
      outlineColor
    ),
    '&.Mui-disabled': disabledStyles
  };
};

export const createSx = <T>(styles: { [K in keyof T]: SxProps<Theme> }) => styles;